import React from 'react';
import { MobileWrapp } from './styled';

const Mobile = () => {
  return (
    <>
      <MobileWrapp>
        <h1>App only has a desktop version at the moment :(</h1>
      </MobileWrapp>
    </>
  );
};

export default Mobile;
